module.exports = __webpack_public_path__ + "static/media/growth-icon.c07aad79.svg";